module.exports = __webpack_public_path__ + "img/thumb_01.87b19f97.jpg";